import React from 'react';
import { Box, ButtonBase } from '@mui/material'; 
import { useTheme } from '@mui/material/styles';
import { getImage, ImageSize } from '@shared/utils/imageFormat';

const connectionStyles =  (theme) => ({
  imageLogo: {
    width: '25px !important',
    height: '25px !important',
    borderRadius: '5px !important',
    backgroundColor: '#000000 !important',
    backgroundSize: 'cover !important',
    backgroundPosition: 'center !important',
    marginRight: '8px !important',
  },
  eventCircle: {
    marginRight: '8px !important',
    width: '12px !important',
    height: '12px !important',
    borderRadius: '12px !important',
    backgroundColor: `${theme.palette.primary.main} !important`,
  },
  title: {
    fontWeight: 'bold !important',
    textDecoration: 'underline !important',
  },
});

export const DiscussionConnection = ({ type, picture, title, url = null }) => {
  const theme = useTheme();
  const classes = connectionStyles(theme);
  const IconImg = () =>
    type === 'entity' ? (
      <Box
        sx={classes.imageLogo}
        style={{
          backgroundImage: `url(${getImage(picture, ImageSize.Small)})`,
        }}
      ></Box>
    ) : type === 'event' ? (
      <Box component="span" sx={classes.eventCircle} />
    ) : (
      <Box component="span"></Box>
    );
  return (
    <ButtonBase href={url}>
      <IconImg />
      <Box component="span" sx={classes.title}>{title}</Box>
    </ButtonBase>
  );
};
DiscussionConnection.displayName = 'DiscussionConnection';
